import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import React, {
  useCallback,
  useRef,
  useState,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import { Button, Chip, Divider, IconButton, LinearProgress, Typography } from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../../utilities/AgGridTable";
import Progress from "./Progress";
import { Box, grid } from "@mui/system";
import { blue } from "@mui/material/colors";
import dataSpacePlaning from "./dataSpacePlaning";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import KitchenDesignRequestAssign from "./KitchenDesignRequestAssign";
import Notification from "./Notification";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from "@mui/lab";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import _ from "lodash";
import moment from "moment";


const useStyles = makeStyles((theme) => ({
  root: {},
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#fff !important",
  backgroundColor: blue[500],
  padding: "12px 30px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "inline-block",

  "&:hover": {
    backgroundColor: blue[700],
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;
const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
const uploadMultipleFiles = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.uploadMultipleFiles}`;
const uploadFileForDisplayMaster = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.uploadFileForDisplayMaster}`;

// const Upload = params => {
//   const { data } = params
//   console.log('data', data)
//   const hiddenFileInput = useRef();
//   const [winner, setWinner] = useState({name: data.data.uploadWinnerFile});

//   async function remove() {
//     // hiddenFileInput.current?.value = null;
//     data.data.uploadWinnerFile = '';
    
//     setWinner(null);
//   }

//   const onChange = async (e) => {
//     const fileUploaded = e.target.files[0];
//     if (!fileUploaded) return;
//     const payload = {
//       uploadWinnerFile: fileUploaded,
//     };
//     const response = await OAuthService.addFiles(
//       `${uploadFileForDisplayMaster}?srNo=${data.data.srNo}`,
//       payload
//     );
//     toast.success("Upload Successfully");
//     // data.data.updateData(response.data);
//     setWinner(fileUploaded);
//   };

//   return (
//     <span>
//       {!data.data.uploadWinnerFile && <UploadButton
//         variant="contained"
//         component="label"
//         fullWidth
//         color="primary"
//         ref={hiddenFileInput}
//         onChange={onChange}
//       >
//         UPLOAD WINNER
//         <input type="file" hidden />
//       </UploadButton>}
//       {winner && (
//         <Box>
//         <Chip label={winner.name} onDelete={remove} />
//       </Box>
//       )}
//     </span>
//   );
// };
const Upload = (params) => {
  const { id } = useParams();
  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${params.data?.uploadWinnerFile}?path=${params.data?.uploadWinnerPath}`;
  const hiddenFileInput = useRef();
  const [winner, setWinner] = useState({
    name: params.node.data.uploadWinnerFile,
  });
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  async function remove() {
    // hiddenFileInput.current?.value = null;
    params.node.data.uploadWinnerFile = "";
    setWinner(null);
  }

  function uploadProgressChanged(params){
    const { progress } = params;
    setUploadProgress(progress * 100);
  }
  const onChange = async (e) => {
    const fileUploaded = e.target.files[0];
    setUploading(true);
    if (!fileUploaded) return;
    const payload = {
      uploadWinnerFile: fileUploaded,
      // kitchenQuantites: params.node.data.srNo
    };
    const response = await OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&kitchenQuantites=${params.node.data.srNo}&category=SHR&updatedBy=ramde`,
      payload,
      uploadProgressChanged
    );
    toast.success("Upload Successfully");
    params.node.updateData(response.data);
    setWinner(fileUploaded);
    setUploading(false);
    setUploadProgress(0);
  };

  const downloadFiles = async () => {
    const blob = await fetch(downloadPath, OAuthService.config()).then((resp) =>
      resp.blob()
    );
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = params.node?.data?.uploadWinnerFile;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objUrl);
    document.body.removeChild(a);
  };

  return uploading ? <Box sx={{ display: 'flex', alignItems: 'center' }}>
     <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={uploadProgress} /> 
     </Box>
     <Box sx={{ minWidth: 35 }}>
     <Typography variant="body2" color="text.secondary">
      {Math.round(uploadProgress)}%
     </Typography>
     </Box>
    </Box> :
  <span>
      {!params.node.data.uploadWinnerFile && (
        <UploadButton
          variant="contained"
          component="label"
          fullWidth
          color="primary"
          ref={hiddenFileInput}
          onChange={onChange}
        >
          UPLOAD WINNER
          <input type="file" hidden />
        </UploadButton>
      )}
      {winner && (
        <>
          <Button
            variant="outlined"
            size="small"
            onClick={downloadFiles}
            startIcon={<FuseSvgIcon>heroicons-outline:download</FuseSvgIcon>}
          >
            Download
          </Button>
          <IconButton onClick={remove}>
            <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
          </IconButton>
        </>
      )}
    </span>
};

export default function IndividualKitchenDesign(props) {
  const { id } = useParams();
  const classes = useStyles(props);
  const [notificationContent, setNotificationContent] = useState("");
  const [open, setOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [rowData, setRowData] = useState();
  const [data, setData] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const gridRef = useRef();
  const navigate = useNavigate();
  const [productId, setProductId] = useState([]);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);

  const SelectProduct = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refVendor = useRef();
    const [error, setError] = useState("");
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);

    const getVendorsList = async () => {
      OAuthService.getList(factoryVendorUrl + `?size=1000`)
        .then((list) => {
          const { factoryVendors } = list.data?._embedded;
          const activeVender = factoryVendors.filter((item) => item.active);
          setVendors(
            activeVender?.map((vendor) => ({
              label: vendor.name,
              value: vendor.id,
            }))
          );
          const vendor = factoryVendors.filter(
            (vendor) => vendor.name === data[colDef.field]
          );
          if (vendor.length > 0)
            setSelectedVendor({ value: vendor[0].id, label: vendor[0].name });
        })
        .catch((err) => setError(err.message));
    };

    const handleVendorChange = (value) => {
      if (!value) return;
      data.productId = value.value;
      props.node.setData(data);
      setSelectedVendor(value);
      // setOpenCom(false);
    };

    useEffect(() => {
      getVendorsList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedVendor?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refVendor}
          value={selectedVendor}
          onChange={handleVendorChange}
          options={vendors}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectRange = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    console.log(props);
    const refRange = useRef();
    const [range, setRange] = useState([]);
    const [selectedRange, setSelectedRange] = useState(null);
    const [allItems, setAllItems] = useState([]);

    if (!productId) return;
    const getRangeList = async () => {
      if (!data.product) {
        alert("Please select a product first");
        return;
      }
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );

      setAllItems(productList);
      setRange(
        productList.map((range) => ({
          value: range.productId,
          label: range.productName,
        }))
      );
      const range2 = ranges.filter((r) => r.productName === data[colDef.field]);
      if (range2.length > 0)
        setSelectedRange({
          value: range2[0].productId,
          label: range2[0].productName,
        });

      // OAuthService.getList(rangeUrl + `?vendorId=${data.productId}`)
      //   .then((list) => {
      //     const { ranges } = list.data?._embedded;
      //     console.log('ranges', ranges)

      //   })
      //   .catch((err) => setError(err.message));
    };

    const handleRangeChange = (value) => {
      if (!value) return;
      const selectedRange = allItems.filter(
        (item) => item.productName === value.label
      )[0];
      if (colDef.field === "range1")
        data.priceGroup = selectedRange?.priceGroup?.pgId;
      else if (colDef.field === "range2")
        data.priceGroup2 = selectedRange?.priceGroup?.pgId;
      console.log("value: ", data);
      setSelectedRange(value);
    };

    useEffect(() => {
      getRangeList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedRange?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refRange}
          value={selectedRange}
          onChange={handleRangeChange}
          // // isMulti
          options={range}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectCarCass = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refCarCass = useRef();
    const [carCass, setCarCass] = useState([]);
    const [selectedCarCass, setSelectedCarCass] = useState(null);

    const getCarCassList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      console.log("list", list);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Carcass" === d._class
      );
      setCarCass(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const cc = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (cc.length > 0)
        setSelectedFront({
          label: `${cc[0].productId} ${cc[0].productName}`,
          value: `${cc[0].productId} ${cc[0].productName}`,
        });
    };

    const handleCarCassChange = (value) => {
      if (!value) return;
      setSelectedCarCass(value);
    };

    useEffect(() => {
      getCarCassList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCarCass?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refCarCass}
          value={selectedCarCass}
          onChange={handleCarCassChange}
          options={carCass}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectFront = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refFront = useRef();
    const [front, setFront] = useState([]);
    const [selectedFront, setSelectedFront] = useState(null);

    const getFrontList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );

      console.log("productList", productList);

      setFront(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const SELECTED_FRONT = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (SELECTED_FRONT.length > 0)
        setSelectedFront({
          label: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
          value: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
        });
    };

    const handleFrontChange = (value) => {
      if (!value) return;
      setSelectedFront(value);
    };

    useEffect(() => {
      getFrontList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedFront?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refFront}
          value={selectedFront}
          onChange={handleFrontChange}
          options={front}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectHandle = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refHandle = useRef();
    const [handle, setHandle] = useState([]);
    const [selectedHandle, setSelectedHandle] = useState(null);

    const getHandleList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Handle" === d._class
      );

      setHandle(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const hh = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (hh.length > 0)
        setSelectedHandle({
          label: `${hh[0].productId} ${hh[0].productName}`,
          value: `${hh[0].productId} ${hh[0].productName}`,
        });
    };

    const handleHandleChange = (value) => {
      if (!value) return;
      setSelectedHandle(value);
    };

    useEffect(() => {
      getHandleList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedHandle?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refHandle}
          value={selectedHandle}
          onChange={handleHandleChange}
          options={handle}
          styles={customStyles()}
        />
      </div>
    );
  });

  const [columnDefs, setColumnDefs] = useState([
    // {
    //   headerName: "Sno.",
    //   valueGetter: "node.rowIndex + 1",
    //   maxWidth: 100,
    // },
    { field: "layoutName", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable', },
    {
      field: "product",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectProduct,
      type: 'conditionalEditable'
    },
    {
      field: "range1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectRange,
      type: 'conditionalEditable'
    },
    { field: "priceGroup", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    {
      field: "front1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectFront,
      type: 'conditionalEditable'
    },
    {
      field: "carcass",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectCarCass,
      type: 'conditionalEditable'
    },
    {
      field: "range2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectRange,
      type: 'conditionalEditable'
    },
    { field: "priceGroup2", enableRowGroup: true, minWidth: 200 },
    {
      field: "front2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectFront,
      type: 'conditionalEditable'
    },
    {
      field: "carcass2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectCarCass,
      type: 'conditionalEditable'
    },
    { field: "scheme", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "handleConcept", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    {
      field: "handle1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectHandle,
      type: 'conditionalEditable'
    },
    {
      field: "handle2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectHandle,
      type: 'conditionalEditable'
    },
    { field: "drawerAccFinish", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "drawerType", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "antiStpMat", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "lightings", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "sinkAccsseories", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "workTops", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "plinths", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "remarks", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "assignToDesigners", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "startDate", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    { field: "endDate", enableRowGroup: true, minWidth: 200, type: 'conditionalEditable' },
    {
      field: "uploadWinnerFile",
      minWidth: 200,
      editable: false,
      cellRenderer: Upload,
      type: 'conditionalEditable'
    },
    { field: "status", enableRowGroup: true, editable: false, minWidth: 200, tooltipValueGetter: params => params.data.comment },
  ]);

  const handleClose = (value) => {
    setOpen(false);
    const { api } = gridRef.current;
    if (!value || !api) return;

    const selectedRows = api.getSelectedRows().map((rows) => rows.srNo);
    if (selectedRows.length === 0) {
      setNotificationContent("Please select at least one row.");
      return;
    }
    const tempData = {
      ...data,
      kitchenQuantities: data?.kitchenQuantities.map((k) => {
        if (selectedRows.includes(k.srNo))
          return { 
        ...k, 
        assignToDesigners: [value.user.value],
        startDate: moment(value.startDate).format("YYYY-MM-DD"),
        endDate: moment(value.endDate).format("YYYY-MM-DD"),
       };
        else return k;
      }),
    };

    OAuthService.putData(`${url}/${id}`, tempData)
      .then((resp) => setNotificationContent("Data has been posted"))
      .catch((err) =>

        setNotificationContent("An error ocurred while posting data")
      );
  };

  const handleKitchenDesignAssign = () => {
    setOpen(true);
  };

  const handleNotificationClose = () => {
    setNotificationContent("");
  };

  const handleSubmitForReview = async () => {
    const tempData = {
      ...data,
      isDsLifeCyclePassForNextState:
        data?.dsLifeCycle === "INDIVIDUAL_KITCHEN_DESIGN",
      isDsStatusPassForNextState: false,
      kitchenQuantities: gridRef.current.api.getRenderedNodes().map(({ data }) => {
        if(data.status === 'Rejected'){
          const t = _.cloneDeep(data);
          t.status = null;
          t.comment = null;
          return t;
        }
        return data;
      })
    };

    await OAuthService.putData(`${url}/${id}`, tempData).then((resp) => {
      setCurrentStatus(resp.data?.dsLifeCycle);
      setNotificationContent(
        "Data has successfully been submitted for review."
      );
    });
    // navigate("/design-studio/individual-kitchen-design-review/" + id);
  };

  const loadData = async () => {
    try {
      const token =
        localStorage &&
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
      const list = await OAuthService.getList(`${url}/${id}`);
      let data = list.data;
      const { preferred_username, email } = token;
      console.log(data);
      if (data.createdByUser === email || data.assignees.includes(email)) {
        setRowData(data?.kitchenQuantities);
      } else {
        // console.log(data?.spacePlans)
        console.log(preferred_username);
        setRowData(
          data?.kitchenQuantities?.filter((sp) =>
            sp.assignToDesigners?.includes(preferred_username)
          )
        );
      }
      setData(data)
      setRowData(data?.kitchenQuantities);
      setCurrentStatus(data?.dsLifeCycle);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const handleBack = () => {
    if(data.designStudioCategory === "SHR") {
      navigate("/design-studio/space-planing-review/" + id);
    } else {
      navigate("/design-studio/request-review/" + id);
    }
  };

  const hiddenPdfFile = useRef(null);
  const hiddenPresentationFile = useRef(null);
  const [pdf, setPDF] = useState(null);
  const [presentation, setPresentation] = useState(null);

  const removePdf = () => {
    hiddenPdfFile.current.value = null;
    setPDF(null);
  };
  const removePresentation = () => {
    hiddenPresentationFile.current.value = null;
    setPresentation(null);
  };
  const onPDFChange = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const payload = {
      prvFile: fileUploaded,
    };
    OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&category=SHR&updatedBy=ramde`,
      payload
    );
    toast.success("Upload Successfully");
    setPDF(fileUploaded);
    const formData = new FormData();
    formData.append("File", pdf);
  };

  const onPresentationChange = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const payload = {
      presentationFile: fileUploaded,
    };
    OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&category=SHR&updatedBy=ramde`,
      payload
    );
    toast.success("Upload Successfully");
    setPresentation(fileUploaded);
    const formData = new FormData();
    formData.append("File", presentation);
  };

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Individual Kitchen Design"
            pageName="Individual Kitchen Design"
            showPaginationDropdown={showPaginationDropdown}
            handleSubmitForReview={handleSubmitForReview}
            handleBack={handleBack}
            requestCategory={data?.designStudioCategory}
            status={currentStatus}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
              <Progress currentStep={5} category={data?.designStudioCategory} />
              <Box sx={{ my: 3 }}>
                {data?.designStudioCategory === 'SHR' && <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between mb-16">
                  <Typography variant="subtitle1">Ground Floor</Typography>
                  <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end">
                    <Button
                      variant="contained"
                      color="warning"
                      size="large"
                      disabled={currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"}
                      onClick={
                        currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"
                          ? () => {}
                          : handleKitchenDesignAssign
                      }
                    >
                      Kitchen Design Assign
                    </Button>
                  </div>
                </div>}
                <div style={{ height: "400px" }}>
                  <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    //onCellValueChanged={onRowValueChanged}
                    columnTypes={{
                      conditionalEditable: {
                        editable: params => params.data.status !== 'Approved'
                      }
                    }}
                  />
                </div>
              </Box>
              <Typography variant="subtitle1" className="mb-16">
                Upload PRW and Presentation
              </Typography>
              <Box className="flex">
                <div>
                  <ColorButton
                    variant="contained"
                    component="label"
                    className="mr-10"
                    disabled={
                      pdf || currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"
                    }
                  >
                    UPLOAD PRW
                    {console.log('currentStatus', pdf || currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN")}
                    <input
                      type="file"
                      hidden
                      className="file"
                      ref={hiddenPdfFile}
                      onChange={onPDFChange}
                      disabled={
                        pdf || currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"
                      }
                    />
                  </ColorButton>
                  {pdf && (
                    <Box className="mt-16">
                      <Chip label={pdf.name} onDelete={removePdf} />
                    </Box>
                  )}
                </div>
                <div>
                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={
                      presentation ||
                      currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"
                    }
                  >
                    UPLOAD PRESENTATION
                    <input
                      type="file"
                      className="file"
                      hidden
                      onChange={onPresentationChange}
                      disabled={
                        presentation ||
                        currentStatus !== "INDIVIDUAL_KITCHEN_DESIGN"
                      }
                    />
                  </ColorButton>
                  {presentation && (
                    <Box className="mt-16">
                      <Chip
                        label={presentation.name}
                        onDelete={removePresentation}
                      />
                    </Box>
                  )}
                </div>
              </Box>
              {data?.comments?.additionalProp2 > 0 && (
                <>
                  <Box className="mt-16 p-8">
                    <Typography variant="subtitle1">Comment</Typography>
                    <Divider sx={{ my: 2 }} />
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                      }}
                    >
                      {data?.comments?.additionalProp2?.map((comment) => (
                        <TimelineItem>
                          <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector />
                          </TimelineSeparator>
                          <TimelineContent>
                            <div>
                              <strong>{comment.lastModifyBy}</strong> assigned
                              you for request change
                            </div>
                            <div className="flex flex-col sm:flex-row sm:items-center mt-8 sm:mt-4 sm:space-x-8 text-md leading-5">
                              <Typography variant="body1" className="text-13">
                                {comment.lastModifiedDate}
                              </Typography>
                            </div>
                            <Box className="mt-16 py-16 px-20 rounded-lg border">
                              {comment.comment}
                            </Box>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                    </Timeline>
                  </Box>
                </>
              )}
              <Divider sx={{ my: 2, pt: 2 }} />
              <div className="pt-16 mt-10">
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  disabled={
                    currentStatus === "INDIVIDUAL_KITCHEN_DESIGN_REVIEW"
                  }
                  onClick={
                    currentStatus === "INDIVIDUAL_KITCHEN_DESIGN_REVIEW"
                      ? () => {}
                      : handleSubmitForReview
                  }
                >
                  Submit for Review
                </Button>
              </div>
            </div>
          </>
        }
        innerScroll
      />
      <KitchenDesignRequestAssign open={open} handleClose={handleClose} />
      <Notification
        open={notificationContent !== ""}
        onClose={handleNotificationClose}
        content={notificationContent}
      />
    </>
  );
}
